"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
const contractor_types_1 = require("./contractor.types");
const contractor_1 = require("services/master-data/contractor");
const getDataGrid = (dataStates) => (dispatch) => __awaiter(void 0, void 0, void 0, function* () {
    const response = yield (0, contractor_1.getMasterContractor)(dataStates);
    if (response.isError) {
        const payload = {
            errorCode: response.errorCode,
            errorMessage: response.errorMessage,
            isError: true
        };
        dispatch({ type: contractor_types_1.contractorTypes.SET_ERROR, payload });
    }
    else {
        const payload = {
            count: response.countData,
            dataGrid: response.data.map(item => {
                return Object.assign(Object.assign({}, item), { created_date: new Date(item.created_date), modified_date: new Date(item.modified_date) });
            })
        };
        dispatch({ type: contractor_types_1.contractorTypes.SET_DATA_GRID, payload });
    }
});
const onDataStateChange = (dataStates) => (dispatch) => __awaiter(void 0, void 0, void 0, function* () {
    const res = yield (0, contractor_1.getMasterContractor)(dataStates);
    const payload = {
        dataGrid: res.isError ? [] : res.data.map(item => {
            return Object.assign(Object.assign({}, item), { created_date: new Date(item.created_date), modified_date: new Date(item.modified_date) });
        }),
        dataStates
    };
    dispatch({ type: contractor_types_1.contractorTypes.ON_PAGE_CHANGE, payload });
});
const onFilterChange = (payload) => dispatch => {
    dispatch({ type: contractor_types_1.contractorTypes.ON_FILTER_CHANGE, payload });
};
const onSortChange = (payload) => dispatch => {
    dispatch({ type: contractor_types_1.contractorTypes.ON_SORT_CHANGE, payload });
};
const onClickMutation = (payload) => dispatch => {
    dispatch({ type: contractor_types_1.contractorTypes.ON_MUTATION_CLICK, payload });
};
const onSaveDataItem = payload => (dispatch) => __awaiter(void 0, void 0, void 0, function* () {
    const { mutationMode, dataItem, formdata } = payload;
    const response = mutationMode === 'add'
        ? yield (0, contractor_1.postContractorData)(formdata)
        : yield (0, contractor_1.putContractorData)(formdata);
    const isSuccess = !response.isError;
    if (isSuccess) {
        dispatch({
            type: contractor_types_1.contractorTypes.ON_SAVE_DATAITEM,
            payload: {
                mutationMode,
                dataItem,
                isSuccess: !response.isError
            }
        });
    }
    else {
        dispatch({ type: contractor_types_1.contractorTypes.SET_ERROR, payload: Object.assign(Object.assign({}, payload), { isError: response.isError, errorCode: response.errorCode, errorMessage: response.errorMessage }) });
    }
});
const onGetDataEnum = () => (dispatch) => __awaiter(void 0, void 0, void 0, function* () {
    const response = yield (0, contractor_1.getEnum)();
    dispatch({ type: contractor_types_1.contractorTypes.SET_DATA_ENUM, payload: response.data });
});
const onDeleteDataItem = (payload) => (dispatch) => __awaiter(void 0, void 0, void 0, function* () {
    const { mutationMode, dataItem } = payload;
    const response = yield (0, contractor_1.deleteContractorData)({ id: dataItem.id });
    const isSuccess = !response.isError;
    if (isSuccess) {
        dispatch({
            type: contractor_types_1.contractorTypes.ON_DELETE_DATAITEM,
            payload: {
                dataItem,
                mutationMode,
                isSuccess: !response.isError
            }
        });
    }
    else {
        dispatch({ type: contractor_types_1.contractorTypes.SET_ERROR, payload: Object.assign(Object.assign({}, payload), { isError: response.isError, errorCode: response.errorCode, errorMessage: response.errorMessage }) });
    }
});
const toggleError = payload => dispatch => {
    dispatch({ type: contractor_types_1.contractorTypes.SET_ERROR, payload });
};
const onLoading = () => dispatch => {
    dispatch({ type: contractor_types_1.contractorTypes.SET_LOADING, payload: true });
};
exports.default = {
    getDataGrid,
    onDataStateChange,
    onClickMutation,
    onSaveDataItem,
    onGetDataEnum,
    onDeleteDataItem,
    onFilterChange,
    onSortChange,
    toggleError,
    onLoading
};
